import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/csv;charset=UTF-8';
const EXCEL_EXTENSION = '.csv';

@Injectable({
  providedIn: 'root'
})
export class SelfService {

  constructor(private readonly http: HttpClient,
    private readonly bpgCommonService: BpgCommonService) { }
  URI: string = ConstantValues.userManagementApiUrl.userManagementUrl;
  areaOfImpactListApi: string = ConstantValues.userManagementApiUrl.areaOfImpactList;
  areaOfImpactSaveApi: string = ConstantValues.userManagementApiUrl.saveAreaOfImpact;
  areaOfImpactDeleteApi: string = ConstantValues.userManagementApiUrl.deleteAreaOfImpact;
  demographicsListApi: string = ConstantValues.userManagementApiUrl.demographicsList;
  demographicsSaveApi: string = ConstantValues.userManagementApiUrl.saveDemographic;
  demographicsDeleteApi: string = ConstantValues.userManagementApiUrl.deleteDemographic;
  bpgListApi: string = ConstantValues.userManagementApiUrl.bpgList;
  bpgSaveApi: string = ConstantValues.userManagementApiUrl.saveBpg;
  bpgDeleteApi: string = ConstantValues.userManagementApiUrl.deleteBpg;
  skillListApi: string = ConstantValues.userManagementApiUrl.skillList;
  skillSaveApi: string = ConstantValues.userManagementApiUrl.saveSkill;
  skillDeleteApi: string = ConstantValues.userManagementApiUrl.deleteSkill;
  userListApi: string = ConstantValues.userManagementApiUrl.userList;
  siteSaveApi: string = ConstantValues.userManagementApiUrl.siteSave;
  siteListApi: string = ConstantValues.userManagementApiUrl.siteList;
  siteDeleteApi: string = ConstantValues.userManagementApiUrl.deleteSite;
  chapterListApi: string = ConstantValues.userManagementApiUrl.chapterList;
  chapterSaveApi: string = ConstantValues.userManagementApiUrl.saveChapter;
  chapterDeleteApi: string = ConstantValues.userManagementApiUrl.deleteChapter;
  landingData: any = ConstantValues.membershipApiUrl.landingDto;
  listAllSitesApi: string = ConstantValues.userManagementApiUrl.listAllSites;
  listAllChaptersApi: string = ConstantValues.userManagementApiUrl.listAllChapters;
  listFullChaptersApi: string = ConstantValues.userManagementApiUrl.listFullChapters;
  bpgPageApi: string = ConstantValues.userManagementApiUrl.bpgListPage;
  skillPageApi: string = ConstantValues.userManagementApiUrl.skillListPage;
  areaOfImpactPageApi: string = ConstantValues.userManagementApiUrl.areaOfImpactListPage;
  chapterListByBpgApi: string = ConstantValues.userManagementApiUrl.chapterListByBpg;
  diSaveApi: string = ConstantValues.userManagementApiUrl.diSave;
  diAddMasterApi = ConstantValues.userManagementApiUrl.diAdd;
  diAddNewsApi = ConstantValues.userManagementApiUrl.diNewsAdd;
  diAddResourceApi = ConstantValues.userManagementApiUrl.diResourceAdd;
  diReTeamAddApi = ConstantValues.userManagementApiUrl.diReTeamAdd;
  diNaacAddApi = ConstantValues.userManagementApiUrl.diNaacAdd;
  getDiMasterListApi: string = ConstantValues.userManagementApiUrl.getDiMasterList;
  getDiNewsListApi: string = ConstantValues.userManagementApiUrl.getDiNewsList;
  getDiResouceListApi: string = ConstantValues.userManagementApiUrl.getDiResouceList;
  getReteamListApi = ConstantValues.userManagementApiUrl.getReteamList;
  getNaacListApi = ConstantValues.userManagementApiUrl.getNaacList;
  deleteDiApi = ConstantValues.userManagementApiUrl.deleteDi;
  addGalleryApi = ConstantValues.userManagementApiUrl.addGallery;
  getGalleryListApi = ConstantValues.userManagementApiUrl.getGalleryList;
  deleteChapterGallery = ConstantValues.userManagementApiUrl.deleteChapterGallery;
  addDocumentsFolderApi = ConstantValues.userManagementApiUrl.addDocumentsFolder;
  getDocumentsFolderListApi = ConstantValues.userManagementApiUrl.getDocumentsFolderList;
  deleteDocumentsFolderApi = ConstantValues.userManagementApiUrl.deleteDocumentsFolder;
  membershipReportApi = ConstantValues.userManagementApiUrl.membershipReport;
  getBannerListApi = ConstantValues.userManagementApiUrl.getBannerList;
  deleteBannerApi = ConstantValues.userManagementApiUrl.deleteBannerList;
  addDiDocumentsFolderApi = ConstantValues.userManagementApiUrl.addDiDocumentsFolder;
  getDiDocumentsFolderApi = ConstantValues.userManagementApiUrl.getDiDocumentsFolder;
  deleteDiDocumentsFolderApi = ConstantValues.userManagementApiUrl.deleteDiDocumentsFolder;
  siteMapApi = ConstantValues.userManagementApiUrl.siteMap;
  eachBpgApi = ConstantValues.userManagementApiUrl.eachBpg;
  naacAddAffinityApi = ConstantValues.userManagementApiUrl.naacAddAffinity;
  addnaacMasterApi = ConstantValues.userManagementApiUrl.addnaacMaster;
  addnaacNewsApi = ConstantValues.userManagementApiUrl.addnaacNews;
  addnaacReTeamApi = ConstantValues.userManagementApiUrl.addnaacReTeam;
  addnaacResourceApi = ConstantValues.userManagementApiUrl.addnaacResource;
  getnaacBannerListApi = ConstantValues.userManagementApiUrl.getnaacBannerList;
  getnaacNewsApi = ConstantValues.userManagementApiUrl.getnaacNews;
  getnaacREteamApi = ConstantValues.userManagementApiUrl.getnaacREteam;
  getnaacResourceApi = ConstantValues.userManagementApiUrl.getnaacResource;
  getnaacAffinityListApi = ConstantValues.userManagementApiUrl.getnaacAffinity;
  deleteNaacBannerApi = ConstantValues.userManagementApiUrl.deleteNaacBanner;
  deletenaacApi = ConstantValues.userManagementApiUrl.deletenaac;
  addNaacDocumentsFolderApi = ConstantValues.userManagementApiUrl.addNaacDocumentsFolder;
  getNaacDocumentsFolderApi = ConstantValues.userManagementApiUrl.getNaacDocumentsFolder;
  deleteNaacDocumentsFolderApi = ConstantValues.userManagementApiUrl.deleteNaacDocumentsFolder;
  deleteNaacAffinityApi = ConstantValues.userManagementApiUrl.deleteNaacAffinity;
  getMapDataforNaacApi = ConstantValues.userManagementApiUrl.getMapDataforNaac;
  getsiteDetailsApi = ConstantValues.userManagementApiUrl.getsiteDetails;
  getSummaryDetailsApi = ConstantValues.userManagementApiUrl.getSummaryDetails;
  getNaacEventsApi = ConstantValues.userManagementApiUrl.getNaacEvents;
  getAllNaacApi: string = ConstantValues.userManagementApiUrl.naacList;
  addChapterAnnouncementApi: string = ConstantValues.userManagementApiUrl.addChapterAnnouncement;
  getChapterAnnouncementListApi: string = ConstantValues.userManagementApiUrl.getChapterAnnouncement;
  deleteChapterAnnouncementApi = ConstantValues.userManagementApiUrl.deleteChapterAnnouncement;
  sendChapterFeedbackApi = ConstantValues.userManagementApiUrl.sendChapterFeedback;
  getChapterFeedbackApi = ConstantValues.userManagementApiUrl.getChapterFeedback
  sendChapterNotificationApi = ConstantValues.userManagementApiUrl.sendChapterNotification;
  addChapterBoardMemberApi = ConstantValues.userManagementApiUrl.addChapterBoardMember;
  getChapterBoardMemberApi = ConstantValues.userManagementApiUrl.getChapterBoardMember;
  deleteChapterBoardMemberApi = ConstantValues.userManagementApiUrl.deleteChapterBoardMember;
  getChapterStatusApi = ConstantValues.userManagementApiUrl.getChapterStatus;
  trackPostCastViewsApi = ConstantValues.userManagementApiUrl.trackPostCastViews;
  getUserDtlsApi: string = ConstantValues.userManagementApiUrl.getUserDtls;
  updateNewSiteApi: string = ConstantValues.userManagementApiUrl.updateNewSite;
  getVirtualBpgApi: string = ConstantValues.userManagementApiUrl.getVirtualBpg;
  getEnrolledBpgApi: string = ConstantValues.userManagementApiUrl.getEnrolledBpg;
  saveMembershipApi: string = ConstantValues.userManagementApiUrl.saveMembership;
  membershipSitesApi: string = ConstantValues.userManagementApiUrl.getMembershipsites;
  getpushNotificationLogsDataApi: string = ConstantValues.userManagementApiUrl.getpushNotificationLogs;
  ergTncSaveApi: string = ConstantValues.userManagementApiUrl.ergTncSave;
  ergTncGetApi: string = ConstantValues.userManagementApiUrl.ergTncGet;
  ergTncGetAllApi: string = ConstantValues.userManagementApiUrl.ergTncGetAll;


  /** For service call to GET areas of impact
    * @class AreaOfImpactService
    * @method getAllAreaOfImpact
    * @param landingData
    * @returns Observable
    */

  public getAllAreaOfImpact(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.areaOfImpactListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))

  }

  /** For service call to SAVE areas of impact
   * @class AreaOfImpactService
   * @method saveAllAreaOfImpact
   * @param landingData
   * @returns Observable
   */

  public saveAllAreaOfImpact(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.areaOfImpactSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

  /** For service call to Delete areas of impact
    * @class AreaOfImpactService
    * @method deleteAllAreaOfImpact
    * @param landingData
    * @returns Observable
    */

  public deleteAllAreaOfImpact(id): Observable<any> {

    return this.http.delete(this.URI + this.areaOfImpactDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))

  }


  /** For service call to getAllDemographics
   * @class DemographicsService
   * @method listDemographics
   * @param landingData
   * @returns Observable
   */
  public getAllDemographics(): Observable<any> {

    return this.http.post(this.URI + this.demographicsListApi, this.landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

  /** For service call to save All Demographics
   * @class DemographicsService
   * @method saveDemographics
   * @param landingData
   * @returns Observable
   */
  public saveAllDemographics(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.demographicsSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }


  /** For service call to deleteDemographic
  * @class DemographicsService
  * @method deleteDemographics
  * @param id
  * @returns Observable
  */
  public deleteDemographic(id): Observable<any> {

    return this.http.delete(this.URI + this.demographicsDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))

  }


  /** For service call to GET BPG's
    * @class BPGService
    * @method getAllBpg
    * @param landingData
    * @returns Observable
    */

  public getAllBpg(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.bpgListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

  /** For service call to GET BPG's
  * @class BPGService
  * @method getAllBpg
  * @param landingData
  * @returns Observable
  */


  /** For service call to GET BPG's
  * @class BPGService
  * @method getAllBpg
  * @param landingData
  * @returns Observable
  */

  public getVirtualBpgs(userId): Observable<any> {


    return this.http.get(this.URI + this.getVirtualBpgApi + userId, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to POST Membership Form
* @class BPGService
* @method saveMembership
* @param landingData
* @returns Observable
*/

  public saveMembership(membershipData): Observable<any> {
    return this.http.post(this.URI + this.saveMembershipApi, membershipData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to GET BPG's
* @class BPGService
* @method getAllBpg
* @param landingData
* @returns Observable
*/

  public getEnrolledBpg(userId): Observable<any> {

    return this.http.get(this.URI + this.getEnrolledBpgApi + userId, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to GET NAAC's
  * @class BPGService
  * @method getAllNaac
  * @param landingData
  * @returns Observable
  */

  public getAllNaac(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.getAllNaacApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

  /** For service call to SAVE BPG
   * @class BPGService
   * @method saveAllBpg
   * @param landingData
   * @returns Observable
   */

  public saveAllBpg(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.bpgSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

  /** For service call to Delete BPG
  * @class BPGService
  * @method deleteBpg
  * @param landingData
  * @returns Observable
  */

  public deleteBpg(id): Observable<any> {

    return this.http.delete(this.URI + this.bpgDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
  }

  /** For service call to GET SKILL
* @class SkillsService
* @method getAllSkill
* @param landingData
* @returns Observable
*/

  public getAllSkill(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.skillListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

  /** For service call to SAVE SKILL
  * @class SkillsService
  * @method saveAllSkill
  * @param landingData
  * @returns Observable
  */

  public saveAllSkill(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.skillSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

  /** For service call to Delete SKILL
   * @class SkillsService
   * @method deleteSkill
   * @param landingData
   * @returns Observable
   */

  public deleteSkill(id): Observable<any> {

    return this.http.delete(this.URI + this.skillDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
  }


  /** For service call to GET USER's
 * @class 
 * @method getUserDropDowns
 * @param 
 * @returns Observable
 */

  public getUserDropDown(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.userListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))

  }
  /** For service call to GET USER's
* @class 
* @method getUserDropDowns
* @param 
* @returns Observable
*/

  public getUserDtls(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.getUserDtlsApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))


  }

  /** For service call to SAVE Site
   * @class SITEService
   * @method saveAllSite
   * @param landingData
   * @returns Observable
   */

  public saveAllSite(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.siteSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to GET BPG's
   * @class BPGService
   * @method getAllBpg
   * @param landingData
   * @returns Observable
   */

  public getAllSite(): Observable<any> {

    return this.http.post(this.URI + this.siteListApi, this.landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))

  }


  /** For service call to GET Sites for Map
 * @class BPGService
 * @method getAllSitesforMap
 * @param landingData
 * @returns Observable
 */

  public getsiteMap(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.siteMapApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))

  }




  /** For service call to GET Sites for Naac Home Screen
 * @class BPGService
 * @method getMapDataforNaac
 * @param landingData
 * @returns Observable
 */

  public getMapDataforNaac(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.getMapDataforNaacApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))

  }



  /** For service call to GET Bpg for Map
 * @class BPGService
 * @method getEachBpgforMap
 * @param landingData
 * @returns Observable
 */

  public getEachBpg(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.eachBpgApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))

  }
  /** For service call to Delete Site
   * @class BPGService
   * @method deleteBpg
   * @param landingData
   * @returns Observable
   */

  public deleteSite(id): Observable<any> {

    return this.http.delete(this.URI + this.siteDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }


  /** For service call to GET CHAPTER
  * @class ChapterService
  * @method getAllSkill
  * @param landingData
  * @returns Observable
  */

  public getAllChapter(landingData: any): Observable<any> {
    return this.http.post(this.URI + this.chapterListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))

  }

  /** For service call to SAVE CHAPTER
  * @class ChapterService
  * @method saveAllSkill
  * @param landingData
  * @returns Observable
  */

  public saveAllChapter(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.chapterSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to Delete CHAPTER
   * @class ChapterService
   * @method deleteChapter
   * @param landingData
   * @returns Observable
   */

  public deleteChapter(id): Observable<any> {

    return this.http.delete(this.URI + this.chapterDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
  }

  /** For service call to GET BPG's
  * @class SelfService
  * @method getAllSites
  * @param landingData
  * @returns Observable
  */

  public getAllSiteList(landingData): Observable<any> {

    return this.http.post(this.URI + this.listAllSitesApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))

  }

  /** For service call to GET Chapters
   * @class SelfService
   * @method getAllChapters
   * @param landingData
   * @returns Observable
   */

  public getAllChapterList(landingData): Observable<any> {

    return this.http.post(this.URI + this.listAllChaptersApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))

  }

  /** For service call to GET Chapters
 * @class SelfService
 * @method getAllChapterswithAllStatus
 * @param landingData
 * @returns Observable
 */

  public getFullChapterList(landingData): Observable<any> {

    return this.http.post(this.URI + this.listFullChaptersApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))

  }

  /** For service call to GET BPG pages list
   * @class SelfService
   * @method getBpgListPage
   * @param landingData
   * @returns Observable
   */

  public getBpgListPage(landingData): Observable<any> {

    return this.http.post(this.URI + this.bpgPageApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }


  /** For service call to GET Skill list as page
 * @class SelfService
 * @method getSkillListPage
 * @param landingData
 * @returns Observable
 */

  public getSkillListPage(landingData): Observable<any> {

    return this.http.post(this.URI + this.skillPageApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

  /** For service call to GET Area of impact list as page
  * @class SelfService
  * @method getAreaOfImpactListPage
  * @param landingData
  * @returns Observable
  */

  public getAreaOfImpactListPage(landingData): Observable<any> {

    return this.http.post(this.URI + this.areaOfImpactPageApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

  /** For service call to GET CHAPTER
   * @class ChapterService
   * @method getChapterByBpg
   * @param landingData
   * @returns Observable
   */

  public getChapterByBpg(landingData: any): Observable<any> {
    return this.http.post(this.URI + this.chapterListByBpgApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))

  }

  /** For service call to get bpg di master List
   * @class diService
   * @method getDiMasterList
   * @param landingData
   * @returns Observable
   **/
  public getDiMasterList(landingData): Observable<any> {

    return this.http.post(this.URI + this.getDiMasterListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get bpg di news List
    * @class diService
    * @method getDiNewsList
    * @param landingData
    * @returns Observable
    **/
  public getDiNewsList(landingData): Observable<any> {

    return this.http.post(this.URI + this.getDiNewsListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get bpg NAAC news List
  * @class diService
  * @method getnaacnewsList
  * @param landingData
  * @returns Observable
  **/
  public getnaacnewsList(landingData): Observable<any> {

    return this.http.post(this.URI + this.getnaacNewsApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get bpg NAAC Affinity List
* @class naacService
* @method getnaacAffinityList
* @param landingData
* @returns Observable
**/
  public getnaacAffinityList(landingData): Observable<any> {

    return this.http.post(this.URI + this.getnaacAffinityListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to update new site
* @class NavigationComponent
* @method updateNewSite
* @param landingData
* @returns Observable
**/
  updateNewSite(siteData): Observable<any> {

    return this.http.post(this.URI + this.updateNewSiteApi, siteData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get bpg di resource List
   * @class diService
   * @method getDiResouceList
   * @param landingData
   * @returns Observable
   **/
  public getDiResouceList(landingData): Observable<any> {
    return this.http.post(this.URI + this.getDiResouceListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get bpg di reTeam List
  * @class diService
  * @method getReteamList
  * @param landingData
  * @returns Observable
  **/
  public getReteamList(landingData): Observable<any> {
    return this.http.post(this.URI + this.getReteamListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to get bpg naac reTeam List
   * @class diService
   * @method getReteamList
   * @param landingData
   * @returns Observable
   **/
  public getnaacREteam(landingData): Observable<any> {
    return this.http.post(this.URI + this.getnaacREteamApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get chapter board member list
 * @class selfService
 * @method getChapterBoardMember
 * @param landingData
 * @returns Observable
 **/
  public getChapterBoardMember(landingData): Observable<any> {
    return this.http.post(this.URI + this.getChapterBoardMemberApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to get status of chapter status
 * @class selfService
 * @method getChapterStatus
 * @param landingData
 * @returns Observable
 **/
  public getChapterStatus(landingData): Observable<any> {
    return this.http.post(this.URI + this.getChapterStatusApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to get bpg naac event List
 * @class naacService
 * @method getNaacEvents
 * @param landingData
 * @returns Observable
 **/
  public getNaacEvents(landingData): Observable<any> {
    return this.http.post(this.URI + this.getNaacEventsApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to add bpg di master List
   * @class diService
   * @method diAddMaster
   * @param landingData
   * @returns Observable
   **/
  public diAddMaster(diData): Observable<any> {

    return this.http.post(this.URI + this.diAddMasterApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to add naac Banner
 * @class diService
 * @method naacMaster
 * @param landingData
 * @returns Observable
 **/
  public addnaacMaster(naacData): Observable<any> {

    return this.http.post(this.URI + this.addnaacMasterApi, naacData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to delete Naac banner image
 * @class bannerImage
 * @method getdiBannerList
 * @param landingData
 * @returns Observable
 **/
  public deleteNaacBanner(id): Observable<any> {
    return this.http.delete(this.URI + this.deleteNaacBannerApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
  }



  /** For service call to delete Naac 
 * @class bannerImage
 * @method getdiBannerList
 * @param landingData
 * @returns Observable
 **/
  public deleteNaacAffinity(id): Observable<any> {
    return this.http.delete(this.URI + this.deleteNaacAffinityApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
  }
  /** For service call to add bpg di news List
    * @class diService
    * @method diAddNews
    * @param landingData
    * @returns Observable
    **/
  public diAddNews(diData): Observable<any> {
    return this.http.post(this.URI + this.diAddNewsApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to add bpg NAAC news List
  * @class diService
  * @method naacAddNews
  * @param landingData
  * @returns Observable
  **/
  public addnaacNews(naacNews): Observable<any> {
    return this.http.post(this.URI + this.addnaacNewsApi, naacNews, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to add bpg NAAC news List
* @class diService
* @method naacAddAffinity
* @param landingData
* @returns Observable
**/
  public naacAddAffinity(naacNews): Observable<any> {
    return this.http.post(this.URI + this.naacAddAffinityApi, naacNews, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get dashboard details
* @class naacService
* @method getDashboardDetails
* @param landingData
* @returns Observable
**/
  public getsiteDetails(dashBoardData): Observable<any> {
    return this.http.post(this.URI + this.getsiteDetailsApi, dashBoardData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to get dashboard details
* @class naacService
* @method getDashboardDetails
* @param landingData
* @returns Observable
**/
  public getSummaryDetails(summaryData): Observable<any> {
    return this.http.post(this.URI + this.getSummaryDetailsApi, summaryData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to add bpg di resource List
   * @class diService
   * @method diAddResource
   * @param landingData
   * @returns Observable
   **/
  public diAddResource(diData): Observable<any> {
    return this.http.post(this.URI + this.diAddResourceApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to add bpg di reTeam List
   * @class diService
   * @method diReTeamAdd
   * @param landingData
   * @returns Observable
   **/
  public diReTeamAdd(diData): Observable<any> {
    return this.http.post(this.URI + this.diReTeamAddApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to add bpg di reTeam List
   * @class diService
   * @method diReTeamAdd
   * @param landingData
   * @returns Observable
   **/
  public addnaacReTeam(userData): Observable<any> {
    return this.http.post(this.URI + this.addnaacReTeamApi, userData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);

    }))

  }

  /** For service call to add chapter board member
 * @class selfService
 * @method addChapterBoardMember
 * @param landingData
 * @returns Observable
 **/
  public addChapterBoardMember(userData): Observable<any> {
    return this.http.post(this.URI + this.addChapterBoardMemberApi, userData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);

    }))

  }

  /** For service call to add bpg naac resource List
* @class naacService
* @method naacReTeamAdd
* @param landingData
* @returns Observable
**/
  public addnaacResource(diData): Observable<any> {
    return this.http.post(this.URI + this.addnaacResourceApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to add bpg di naac List
  * @class diService
  * @method diNaacAdd
  * @param landingData
  * @returns Observable
  **/
  public diNaacAdd(diData): Observable<any> {
    return this.http.post(this.URI + this.diNaacAddApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get bpg di naac List
   * @class diService
   * @method getNaacList
   * @param landingData
   * @returns Observable
   **/
  public getNaacList(diData): Observable<any> {
    return this.http.post(this.URI + this.getNaacListApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to delete bpg  all di 
   * @class diService
   * @method deleteDi
   * @param landingData
   * @returns Observable
   **/
  public deleteDi(deleteData): Observable<any> {
    return this.http.post(this.URI + this.deleteDiApi, deleteData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to delete bpg  all di 
   * @class diService
   * @method deleteDi
   * @param landingData
   * @returns Observable
   **/
  public deletenaac(deleteData): Observable<any> {
    return this.http.post(this.URI + this.deletenaacApi, deleteData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to delete chapter board member 
 * @class selfService
 * @method deleteChapterBoard
 * @param landingData
 * @returns Observable
 **/
  public deleteChapterBoard(id): Observable<any> {
    return this.http.delete(this.URI + this.deleteChapterBoardMemberApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))

  }
  /** For service call to upload to s3 bucket
     * @class diService
     * @method diput
     * @param url
     * @returns Observable
     */
  public diput(url: string, body: any): Promise<any> {
    const hdr = {
      'Content-Type': 'application/octet-stream'
    };
    const options = { headers: hdr };
    return new Promise((resolve, reject) => {
      this.http.put(url, body, options).toPromise().then(res =>
        resolve(res), (error: any) => {
          const errorMessage = error.message || JSON.stringify(error);
          reject(new Error(errorMessage));
        });
    });
  }


  /** For service call to add chapter-gallery item
  * @class chapterGalleryService
  * @method addGallery
  * @param galleryData
  * @returns Observable
  **/
  public addGallery(galleryData): Observable<any> {

    return this.http.post(this.URI + this.addGalleryApi, galleryData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to add chapter-announcement item
* @class chapterGalleryService
* @method addAnnouncement
* @param galleryData
* @returns Observable
**/
  public addchapterAnnouncement(announcementData): Observable<any> {

    return this.http.post(this.URI + this.addChapterAnnouncementApi, announcementData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get bpg di naac List
  * @class chapterGalleryService
  * @method getChapterGallery
  * @param landingData
  * @returns Observable
  **/
  public getChapterGalleryList(landingData): Observable<any> {
    return this.http.post(this.URI + this.getGalleryListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to track podcast views
* @class PoddastService
* @method PoddastService
* @param landingData
* @returns Observable
**/
  public trackPostCastViews(landingData): Observable<any> {
    return this.http.post(this.URI + this.trackPostCastViewsApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to get bpg di naac List
  * @class chapterGalleryService
  * @method getChapterGallery
  * @param landingData
  * @returns Observable
  **/
  public getChapterAnnouncementList(landingData): Observable<any> {
    return this.http.post(this.URI + this.getChapterAnnouncementListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to send chapter feedback
* @class chapterGalleryService
* @method getChapterGallery
* @param landingData
* @returns Observable
**/
  public sendChapterFeedback(feedbackData): Observable<any> {
    return this.http.post(this.URI + this.sendChapterFeedbackApi, feedbackData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to get chapter feedback
* @class chapterGalleryService
* @method getChapterGallery
* @param landingData
* @returns Observable
**/
  public getChapterFeedback(feedbackData): Observable<any> {
    return this.http.post(this.URI + this.getChapterFeedbackApi, feedbackData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to send chapter notification
* @class chapterGalleryService
* @method getChapterGallery
* @param landingData
* @returns Observable
**/
  public sendChapterNotification(notificationData): Observable<any> {
    return this.http.post(this.URI + this.sendChapterNotificationApi, notificationData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to get banner image
* @class bannerImage
* @method getdiBannerList
* @param landingData
* @returns Observable
**/
  public getdiBannerList(landingData): Observable<any> {
    return this.http.post(this.URI + this.getBannerListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }


  /** For service call to get naac banner data
* @class bannerImage
* @method getnaacBannerList
* @param landingData
* @returns Observable
**/
  public getnaacBannerList(landingData): Observable<any> {
    return this.http.post(this.URI + this.getnaacBannerListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to get banner image
 * @class bannerImage
 * @method getdiBannerList
 * @param landingData
 * @returns Observable
 **/
  public deleteBannerList(id): Observable<any> {


    return this.http.delete(this.URI + this.deleteBannerApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
  }

  /** For service call to Delete CHAPTER
 * @class chapterGalleryService
 * @method deleteGallery
 * @param landingData
 * @returns Observable
 */

  public deleteGallery(id): Observable<any> {

    return this.http.delete(this.URI + this.deleteChapterGallery + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
  }

  /** For service call to Delete CHAPTER Announcement
* @class chapterGalleryService
* @method deleteChapterAnnouncement
* @param landingData
* @returns Observable
*/

  public deleteChapterAnnouncement(id): Observable<any> {

    return this.http.delete(this.URI + this.deleteChapterAnnouncementApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
  }


  /** For service call to add chapter-gallery item
 * @class chapterGalleryService
 * @method addGallery
 * @param galleryData
 * @returns Observable
 **/
  public addDocumentsFolder(folderData): Observable<any> {

    return this.http.post(this.URI + this.addDocumentsFolderApi, folderData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to add di Resourc Folder
* @class addDiDocumentsFolderService
* @method addDiDocumentsFolderService
* @param addFolder
* @returns Observable
**/
  public addDiDocumentsFolder(folderData): Observable<any> {

    return this.http.post(this.URI + this.addDiDocumentsFolderApi, folderData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to add naac Resourc Folder
* @class addNaacDocumentsFolderService
* @method addNaacDocumentsFolderService
* @param addFolder
* @returns Observable
**/
  public addNaacDocumentsFolder(folderData): Observable<any> {

    return this.http.post(this.URI + this.addNaacDocumentsFolderApi, folderData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }


  /** For service call to get di Resourc Folder
* @class getDiDocumentsFolderService
* @method getDiDocumentsFolderService
* @param getFolder
* @returns Observable
**/
  public getDiDocumentsFolder(folderData): Observable<any> {

    return this.http.post(this.URI + this.getDiDocumentsFolderApi, folderData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get naac Resourc Folder
* @class getNaacDocumentsFolderService
* @method getNaacDocumentsFolderService
* @param getFolder
* @returns Observable
**/
  public getNaacDocumentsFolder(folderData): Observable<any> {

    return this.http.post(this.URI + this.getNaacDocumentsFolderApi, folderData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get NAAC Resourc Folder
* @class getnaacResource
* @method getnaacResource
* @param getFolder
* @returns Observable
**/
  public getnaacResource(folderData): Observable<any> {

    return this.http.post(this.URI + this.getnaacResourceApi, folderData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }


  /** For service call to get bpg di naac List
  * @class chapterGalleryService
  * @method getChapterGallery
  * @param landingData
  * @returns Observable
  **/
  public getDocumentsFolderList(landingData): Observable<any> {
    return this.http.post(this.URI + this.getDocumentsFolderListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }


  /** For service call to Delete Folder
* @class deleteDocumentsFolderService
* @method deleteDocumentsFolder
* @param landingData
* @returns Observable
*/

  public deleteDocumentsFolder(id): Observable<any> {

    return this.http.delete(this.URI + this.deleteDocumentsFolderApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
  }

  /** For service call to Delete CHAPTER
* @class chapterGalleryService
* @method deleteGallery
* @param landingData
* @returns Observable
*/

  public deleteDiDocumentsFolder(id): Observable<any> {

    return this.http.delete(this.URI + this.deleteDiDocumentsFolderApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
  }
  /** For service call to Delete NaacDocuments
* @class chapterGalleryService
* @method deleteGallery
* @param landingData
* @returns Observable
*/

  public deleteNaacDocumentsFolder(id): Observable<any> {

    return this.http.delete(this.URI + this.deleteNaacDocumentsFolderApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
  }

  /** For service call to get membership details for membership report
* @class SelfService
* @method getMembershipReport
* @param landingData
* @returns Observable
**/
  public getMembershipReport(landingData): Observable<any> {
    return this.http.post(this.URI + this.membershipReportApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))
  }

  /** For converting json to csv and saving the file
   * @class SelfService
   * @method exportAsExcelFile
   * @param json data, string
   */
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'csv', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName.trim() + EXCEL_EXTENSION);
  }

  /** For service call to GET BPG's
* @class BPGService
* @method getMemershipSites
* @param landingData
* @returns Observable
*/

  public getMembershipSites(userId): Observable<any> {

    return this.http.get(this.URI + this.membershipSitesApi + userId, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))

  }

   /** To get sent eamils by the user 
* @class PushNotificationLog
* @method getpushNotificationLogsData
* @param landingData
* @returns Observable
*/
  public getpushNotificationLogsData(landingData: any): Observable<any> {
    return this.http.post(
      this.URI + this.getpushNotificationLogsDataApi, landingData, this.bpgCommonService.tokenizedHeader()
    );
  }

  public saveErgTnc(payload: any): Observable<any> {
    return this.http.post(this.URI + this.ergTncSaveApi, payload, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }))
  }

  public getErgTnc(payload: any): Observable<any> {
    return this.http.post(this.URI + this.ergTncGetApi, payload, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }))
  }

  public getAllErgTnc(): Observable<any> {
    return this.http.get(this.URI + this.ergTncGetAllApi, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }
}

